
import { defineComponent, PropType, reactive } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'

// realisations
import { blog } from '@/core/realisations/blog.realisation'

// types
import { ArticleT } from '@/core/types/blog.types'

// composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        TheButton,
    },
    props: {
        article: {
            type: Object as PropType<ArticleT>,
            default: null,
        },
    },
    emits: ['deleted'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_deleting: false,
        })

        const deleteArticle = async () => {
            const answer = confirm(
                `Вы действительно хотите удалить статью '${props.article.title}'?`
            )
            if (!answer) return

            try {
                state.is_deleting = true

                await blog.deleteArticle(props.article.id)
                notifications.notify({
                    title: `Статья '${props.article.title}' удалена`,
                    type: 'success',
                })

                emit('deleted', props.article.id)
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При удалении статьи произошла ошибка' })
            } finally {
                state.is_deleting = false
            }
        }

        return { state, deleteArticle }
    },
})
